module.exports = __webpack_public_path__ + "0081706ab748c0b820636e5e0bf8cc13.jpg";